// Dependencies
import React, { FunctionComponent, useRef } from "react";

// Styles
import { Container } from "./styles";

// Types
type WebpInputProps = {
    className: string;
    placeholder: string | null;
    value: string | undefined;
    hasBorder?: boolean;
    invalid?: boolean;
    onWebpInputChange: (e: any) => void;
};

export const WebpInput: FunctionComponent<WebpInputProps> = ({
    invalid = false,
    placeholder,
    value,
    className,
    hasBorder = true,
    onWebpInputChange
}) => {
    const inputRef = useRef<HTMLInputElement>(null);

    return (
        <Container className={className} isInvalid={invalid} hasBorder={hasBorder}>
            <input className="native-input" ref={inputRef} placeholder={placeholder || ""} defaultValue={value} onChange={onWebpInputChange} />
        </Container>
    );
};
